// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__cC3NH","link":"style_link__1KFem"};